import {omneticApi} from '@dms/api/base';

import {
  CreateWorkshopInterestSeriesDefinitionApiArg,
  CreateWorkshopInterestSeriesDefinitionApiResponse,
  CreateWorkshopInterestSeriesDefinitionRequestBodySchema,
  GetWorkshopInterestSeriesDefinitionApiArg,
  GetWorkshopInterestSeriesDefinitionApiArgSchema,
  GetWorkshopInterestSeriesDefinitionApiResponse,
  GetWorkshopInterestSeriesDefinitionListApiArg,
  GetWorkshopInterestSeriesDefinitionListApiArgSchema,
  GetWorkshopInterestSeriesDefinitionListApiResponse,
  GetWorkshopInterestSeriesDefinitionListApiResponseSchema,
  PutWorkshopInterestSeriesDefinitionApiArg,
  PutWorkshopInterestSeriesDefinitionApiArgSchema,
  PutWorkshopInterestSeriesDefinitionApiResponse,
  WorkshopInterestSeriesDefinitionResponseBodySchema,
} from './types';

const injected = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkshopInterestSeriesDefinitionList: build.query<
      GetWorkshopInterestSeriesDefinitionListApiResponse,
      GetWorkshopInterestSeriesDefinitionListApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest-series-definition`,
        queryArg,
      }),
      providesTags: ['WorkshopInterestSeriesDefinitions'],
      extraOptions: {
        requestSchema: GetWorkshopInterestSeriesDefinitionListApiArgSchema,
        responseSchema: GetWorkshopInterestSeriesDefinitionListApiResponseSchema,
      },
    }),

    getWorkshopInterestSeriesDefinition: build.query<
      GetWorkshopInterestSeriesDefinitionApiResponse,
      GetWorkshopInterestSeriesDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest-series-definition/${queryArg.seriesDefinitionId}`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'WorkshopInterestSeriesDefinition', id: queryArg.seriesDefinitionId},
      ],
      extraOptions: {
        requestSchema: GetWorkshopInterestSeriesDefinitionApiArgSchema,
        responseSchema: WorkshopInterestSeriesDefinitionResponseBodySchema,
      },
    }),

    createWorkshopInterestSeriesDefinition: build.mutation<
      CreateWorkshopInterestSeriesDefinitionApiResponse,
      CreateWorkshopInterestSeriesDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest-series-definition`,
        method: 'POST',
        body: queryArg.createWorkshopInterestSeriesDefinitionRequestBody,
        queryArg,
      }),
      invalidatesTags: ['WorkshopInterestSeriesDefinitions'],
      extraOptions: {
        requestSchema: CreateWorkshopInterestSeriesDefinitionRequestBodySchema,
        responseSchema: WorkshopInterestSeriesDefinitionResponseBodySchema,
      },
    }),

    putWorkshopInterestSeriesDefinition: build.mutation<
      PutWorkshopInterestSeriesDefinitionApiResponse,
      PutWorkshopInterestSeriesDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest-series-definition/${queryArg.seriesDefinitionId}`,
        method: 'PUT',
        body: queryArg.putWorkshopInterestSeriesDefinitionRequestBody,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'WorkshopInterestSeriesDefinitions',
        {type: 'WorkshopInterestSeriesDefinition', id: queryArg.seriesDefinitionId},
      ],
      extraOptions: {
        requestSchema: PutWorkshopInterestSeriesDefinitionApiArgSchema,
        responseSchema: WorkshopInterestSeriesDefinitionResponseBodySchema,
      },
    }),
  }),
});

export const {
  useGetWorkshopInterestSeriesDefinitionListQuery,
  useGetWorkshopInterestSeriesDefinitionQuery,
  useLazyGetWorkshopInterestSeriesDefinitionQuery,
  useCreateWorkshopInterestSeriesDefinitionMutation,
  usePutWorkshopInterestSeriesDefinitionMutation,
} = injected;
